import {$} from '../jquery-definition.js';
import 'jquery.equalheights';

$( function() {
	$( '.equal-heights' ).equalHeights( {
		wait: true,
		watch: true
	} );

	checkFilterAlignment();
} );

$( window ).on( 'resize', function() {
	checkFilterAlignment();
} );

function checkFilterAlignment() {
	if ( $( '.case-filter' ).height() > 50 ) {
		$( '.case-filter' ).removeClass( 'text-lg-right' );
	} else {
		$( '.case-filter' ).addClass( 'text-lg-right' );
	}
}
